<label class="form-label" *ngIf="title">{{title}}</label>
<div class="input-group">
  <input
    class="form-control"
    [disabled]="disablePicker"
    [(ngModel)]="dateString"
    (blur)="refreshFromDateString()"
    type="text"
    [placeholder]="placeholder">
  <sb-icon *ngIf="dateString && dateString.length > 0 && !disablePicker" icon="cancel" class="clear-button"
           (click)="clear()">
  </sb-icon>
  <div class="input-group-append" (click)="toggleDatepicker()">
      <span class="input-group-text h-100">
          <sb-icon icon="calendar"></sb-icon>
      </span>
  </div>
  <div class="input-group datetimepicker datepicker-dropdown " *ngIf="!disablePicker">
    <ngb-datepicker
      [showWeekNumbers]="weekNumbers"
      #dp
      [(ngModel)]="dateStruct"
      [minDate]="minDateStruct"
      [startDate]="!enabledDates?dateStruct:minDateStruct"
      [class.d-none]="!visible"
      (select)="toggleDatepicker()"
      [maxDate]="maxDateStruct"
      [markDisabled]="isDisabled"></ngb-datepicker>
  </div>
</div>
